export default IconCurrencySolana => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-solana" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 18h12l4 -4h-12z" />
  <path d="M8 14l-4 -4h12l4 4" />
  <path d="M16 10l4 -4h-12l-4 4" />
</svg>`;